export default __webpack_public_path__ + "b1b9cef90738b4d7c268036db148aa32.png";